import {Decoder, field, object, string} from 'json-bouncer'
import {nullableWithDefaultDecoder} from '../Data/DecodeHelper'
import {Order} from './Order'

export interface DeliveryAddress {
    readonly deliveryName1: string
    readonly deliveryName2: string
    readonly deliveryName3: string
    readonly deliveryName4: string
    readonly deliveryFloor: string
    readonly deliveryRoom: string
    readonly deliveryStreet: string
    readonly deliveryHouseNumber: string
    readonly deliveryZipCode: string
    readonly deliveryCity: string
    readonly deliveryCountry: string
}

export function deliveryAddressDecoder(): Decoder<DeliveryAddress> {
    return object({
        deliveryName1: field('deliveryName1', string()),
        deliveryName2: field('deliveryName2', nullableWithDefaultDecoder('', string())),
        deliveryName3: field('deliveryName3', nullableWithDefaultDecoder('', string())),
        deliveryName4: field('deliveryName4', nullableWithDefaultDecoder('', string())),
        deliveryFloor: field('deliveryFloor', nullableWithDefaultDecoder('', string())),
        deliveryRoom: field('deliveryRoom', nullableWithDefaultDecoder('', string())),
        deliveryStreet: field('deliveryStreet', string()),
        deliveryHouseNumber: field('deliveryHouseNumber', string()),
        deliveryZipCode: field('deliveryZipCode', string()),
        deliveryCity: field('deliveryCity', string()),
        deliveryCountry: field('deliveryCountry', string()),
    })
}

export function fromOrder(order: Order): DeliveryAddress {
    const {
        deliveryName1,
        deliveryName2,
        deliveryName3,
        deliveryName4,
        deliveryFloor,
        deliveryRoom,
        deliveryStreet,
        deliveryHouseNumber,
        deliveryZipCode,
        deliveryCity,
        deliveryCountry,
    } = order
    return {
        deliveryName1,
        deliveryName2,
        deliveryName3,
        deliveryName4,
        deliveryFloor,
        deliveryRoom,
        deliveryStreet,
        deliveryHouseNumber,
        deliveryZipCode,
        deliveryCity,
        deliveryCountry,
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/DeliveryAddress.ts